import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/utils/store';
import '@/utils/vant';
import '@/assets/css/reset.css';
import '@/assets/css/contract.css';
import '@/utils/fastclick';
import '@/utils/filter';

import eruda from 'eruda';
import erudaPixel from 'eruda-pixel';

if (process.env.VUE_APP_ENV !== 'prod') {
  eruda.init();
  eruda.add(erudaPixel);
}

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
